var map = {
	"./abyss_custom_logo.svg": "./src/assets/abyss_custom_logo.svg",
	"./abyss_fabric_logo_white.png": "./src/assets/abyss_fabric_logo_white.png",
	"./abyss_logo_white.png": "./src/assets/abyss_logo_white.png",
	"./arrow.png": "./src/assets/arrow.png",
	"./background.png": "./src/assets/background.png",
	"./blank_plan.png": "./src/assets/blank_plan.png",
	"./box.png": "./src/assets/box.png",
	"./box.svg": "./src/assets/box.svg",
	"./clipboard.svg": "./src/assets/clipboard.svg",
	"./expand_equipment.png": "./src/assets/expand_equipment.png",
	"./filter.png": "./src/assets/filter.png",
	"./folder-cloud.png": "./src/assets/folder-cloud.png",
	"./gallery.svg": "./src/assets/gallery.svg",
	"./images.png": "./src/assets/images.png",
	"./logo.svg": "./src/assets/logo.svg",
	"./max-min.png": "./src/assets/max-min.png",
	"./part.svg": "./src/assets/part.svg",
	"./polygon.png": "./src/assets/polygon.png",
	"./styles/generic.scss": "./src/assets/styles/generic.scss",
	"./zoom_in.png": "./src/assets/zoom_in.png",
	"./zoom_out.png": "./src/assets/zoom_out.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";